import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from 'environments/environment';
import { IProgress } from './profile.const';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiBase + '/profile/v1';
  progress = signal(0);

  getProgress(): Observable<IProgress> {
    return this.http
      .get<IProgress>(`${this.apiUrl}/progress`)
      .pipe(tap((progress) => this.progress.set(progress.total)));
  }
}
